import React, { Component, Fragment } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent'; // od ovoga bi trebala da se napravi globalna komponenta posto se koristi kroz celu registraciju a imamo vise stranica(komponenti) gde nam je potrebno obavestenje
import Slide from '@material-ui/core/Slide'; // od ovoga bi trebala da se napravi globalna komponenta posto se koristi kroz celu registraciju a imamo vise stranica(komponenti) gde nam je potrebno obavestenje
import { Button } from '@material-ui/core';

function TransitionUp(props) {
  return <Slide {...props} direction="up" />;
} // od ovoga bi trebala da se napravi globalna komponenta posto se koristi kroz celu registraciju a imamo vise stranica(komponenti) gde nam je potrebno obavestenje

class SnackbarComponent extends Component {
  state = {
    SnackbarMsg: 'Hugabuga',
    openSnackbar: false,
  };

  componentDidMount() {
    if (this.props.open) {
      this.setState({
        openSnackbar: true,
        Transition: TransitionUp,
        SnackbarMsg: this.props.msg,
      });
    }
  }

  handleCloseSncakbar = () => {
    this.setState({ openSnackbar: false });
    this.props.resetState();
  };

  render() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={this.state.Transition}
        open={this.state.openSnackbar}
        // autoHideDuration={4000}
        onClose={this.handleCloseSncakbar}
        ContentProps={{
          'aria-describedby': 'snackbar-fab-message-id',
          // className: classes.snackbarContent,
        }}
      >
        <SnackbarContent
          className="bc-red"
          aria-describedby="client-snackbar"
          message={
            <span id="snackbar-fab-message-id">{this.state.SnackbarMsg}</span>
          }
          action={
            <Button
              color="inherit"
              size="small"
              onClick={this.handleCloseSncakbar}
            >
              close
            </Button>
          }
        />
      </Snackbar>
      // className={classes.snackbar}
    );
  }
}

export default SnackbarComponent;
